import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { useConfig } from 'src/core/config';

const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        padding: ${theme.spacing(0, 1, 0, 0)};
        display: flex;
        text-decoration: none;
        font-weight: ${theme.typography.fontWeightBold};
`
);

interface LogoSectionProps {
  /** Custom link destination. Defaults to dashboard route from config */
  to?: string;
  /** Logo width. Defaults to 210 */
  width?: number;
}

/**
 * LogoSection - A logo component for section headers and sidebars
 * Similar to Logo but can be used in different layout contexts
 */
export default function LogoSection({ to, width = 210 }: LogoSectionProps) {
  const { name, assets } = useConfig();
  const linkTo = to || '/';

  return (
    <LogoWrapper to={linkTo}>
      <img
        alt={`${name} Logo`}
        width={width}
        src={assets.logo}
      />
    </LogoWrapper>
  );
}

